import type { TFunction } from 'i18next';
import { MIN_PASSWORD_LENGTH } from '@competa/shared';
import { ApiRequestError } from '../api/client';

/**
 * Übersetzt einen beliebigen Fehler in einen für Benutzer verständlichen Text.
 * API-Fehler werden über ihren Code (`errors.<code>`) übersetzt, alles andere als „unbekannt".
 * @param t Übersetzungsfunktion.
 * @param error Der aufgetretene Fehler.
 * @returns Lokalisierter Fehlertext.
 */
export function errorMessage(t: TFunction, error: unknown): string {
  if (error instanceof ApiRequestError) {
    return t(`errors.${error.code}`, { defaultValue: t('errors.unknown') });
  }
  return t('errors.unknown');
}

/**
 * Übersetzt die Feldfehler einer Validierungsantwort (`fields`) in lokalisierte Texte.
 * @param t Übersetzungsfunktion.
 * @param error Der aufgetretene Fehler.
 * @returns Text je Feldname; leer, wenn der Fehler keine Feldfehler enthält.
 */
export function fieldErrors(t: TFunction, error: unknown): Record<string, string> {
  if (!(error instanceof ApiRequestError) || !error.fields) return {};
  return Object.fromEntries(
    Object.entries(error.fields).map(([field, code]) => [
      field,
      t(`fields.${code}`, { defaultValue: t('fields.invalid'), min: MIN_PASSWORD_LENGTH }),
    ]),
  );
}
